export enum E_EChartsWorkerFormatter {
    AREA_BASELINE = 'AREA_BASELINE',
    BALANCE_BARS = 'BALANCE_BARS',
    BAR_STANDARD = 'BAR_STANDARD',
    BAR_PERCENTAGE = 'BAR_PERCENTAGE',
    CANDLESTICK = 'CANDLESTICK',
    LINE_STANDARD = 'LINE_STANDARD',
    MARK_AREA = 'MARK_AREA',
    VERTICAL_LINE_ICON = 'VERTICAL_LINE_ICON',
    SCATTER_STANDARD = 'SCATTER_STANDARD',
    AXIS_TIME = 'AXIS_TIME',
    AXIS_VALUE = 'AXIS_VALUE',
    AXIS_CATEGORY = 'AXIS_CATEGORY'
}

export enum E_EChartsWorkerAction {
    INIT = 'init',
    UPDATE = 'update',
    RESIZE = 'resize',
    READY = 'ready',
    DISPOSE = 'dispose'
}